import { Component } from 'react';
import { formatNumber } from '../../../../common/services/number-formatter';
import Button from '../../../components/Button';

class MaxCharacters extends Component {
    constructor(props) {
        super(props);
        this.state = { changing: false, maximumCharactersPerResponse: this.props.maximumCharactersPerResponse };
    }

    render() {
        if (this.state.changing) {
            return (
                <small className="guided-cycle-card-footer">
                    <span>Maximum characters per question answer</span>&nbsp;
                    <span>
                        <input
                            type="number"
                            min={1}
                            value={this.state.maximumCharactersPerResponse}
                            onChange={e => this.setState({ maximumCharactersPerResponse: e.target.value })}
                        />
                        &nbsp;
                        <Button kind="LINK" onClick={() => this.changeMaximumCharacters()}>
                            Save
                        </Button>
                    </span>
                </small>
            );
        } else {
            return (
                <small className="guided-cycle-card-footer">
                    <span>
                        Question answers are limited to {formatNumber(this.props.maximumCharactersPerResponse)}{' '}
                        characters.
                    </span>
                    &nbsp;
                    <Button kind="LINK" onClick={() => this.setState({ changing: true })}>
                        Change
                    </Button>
                </small>
            );
        }
    }

    changeMaximumCharacters() {
        this.props.onChangeMaximumCharactersPerResponse({
            maximumCharactersPerResponse: this.state.maximumCharactersPerResponse,
        });
        this.setState({ changing: false });
    }
}

export default MaxCharacters;
